import { render, staticRenderFns } from "./BloodParasiteDashboard.vue?vue&type=template&id=9362dcbc"
import script from "./BloodParasiteDashboard.vue?vue&type=script&lang=js"
export * from "./BloodParasiteDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports